import initRules from '@/utils/initRules' // 初始化验证规则
import global from '@/utils/global'
import has from '@/utils/permission'
import {message} from '@/utils/resetMessage'
import idName from '@/utils/idName'

export default {
  install (Vue, options) {
    // 表单验证
    Vue.prototype.$initRules = initRules
    // 全局变量
    Vue.prototype.$global = global
    // 按钮权限
    Vue.prototype.$has = has
    // 重写弹窗
    Vue.prototype.$message = message
    // id名字
    Vue.prototype.$idName = idName
  }
}



// WEBPACK FOOTER //
// ./src/utils/prototype.js